// AppBootstrap.tsx
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import { fetchMe, setUser } from "./features/auth/authSlice";

export function AppBootstrap({ children }: { children: React.ReactNode }) {
  const dispatch = useAppDispatch();
  const { loading, user, error } = useAppSelector((s) => s.auth);

 useEffect(() => {
  dispatch(fetchMe());
}, [dispatch]);


  if (loading || !user) {
    // While /auth/me is in-flight or redirecting
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Failed to load session: {error}</div>;
  }

  return <>{children}</>;
}
